<template>
  <div id="contenedor-main-actividades-ejecucion">
      <actividades
      :idReferencia="idReferencia">
      </actividades>
  </div>
</template>

<script>
import Actividades from '@/views/administracion/actividades/Main.vue';

export default {
  name: 'ActividadesEjecucionMain',
  components: {
    Actividades,
  },
  data() {
    return {
      idReferencia: this.$route.params.idContrato,
    };
  },

};
</script>

<style>

</style>
